var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useState } from 'react';
import { Flows } from '../const';
import { useQuestionnaire } from './use-questionnaire';
import useSettlementEligibilityCheck from './use-settlement-eligibility-check';
import useSettlementEnrollment from './use-settlement-enrollment';
import useSubmitSettlementQuestionnaire from './use-submit-settlement-questionnaire';
var useSettlement = function (isReady) {
    var _a = useState(), plan = _a[0], setPlan = _a[1];
    var _b = useSettlementEligibilityCheck(isReady), data = _b.data, isLoading = _b.isLoading;
    var _c = useQuestionnaire(Flows.SETTLEMENT), questionnaire = _c.questionnaire, questionnaireActions = __rest(_c, ["questionnaire"]);
    var submitQuestionnaire = useSubmitSettlementQuestionnaire(questionnaire.selectedAnswers);
    var enrollment = useSettlementEnrollment();
    return __assign(__assign({ data: data, isLoading: isLoading, questionnaire: questionnaire }, questionnaireActions), { submitQuestionnaire: submitQuestionnaire, enrollment: enrollment, setPlan: setPlan, plan: plan });
};
export default useSettlement;
//# sourceMappingURL=use-settlement.js.map